import React from "react";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import Loader from "@icarius-common/loader";
import { getYesNoArray } from "@icarius-utils/constants";
import useHandleForm from "./useHandleForm";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const gridStyle = { padding: 10 };

const ModuleFormDialog = (props) => {

  const {
    open,
    data,
    submitCallback,
    handleClose,
    isLoading,
  } = props;

  const dispatch = useDispatch();

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    formData,
    setFormValue,
    submit,
  } = useHandleForm(data, submitCallback, openValidationError);

  if (!data) return null;

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"md"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {`${getLocalizedString("updateModule")}: ${formData.name}`}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent style={{ paddingTop: 0 }}>
          <Loader open={isLoading} />
          <Grid container item xs={12}>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id={`label-editable`}>{getLocalizedString("editable")}</InputLabel>
                <Select
                  disabled
                  value={data.editable ? "Y" : "N"}
                  labelId={`label-editable`}
                  id={`select-editable`}
                  margin={"none"}
                >
                  {
                    getYesNoArray().map((item) => (
                      <MenuItem
                        className={"whiteText"}
                        key={item.key}
                        value={item.key}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id={`label-active`}>{getLocalizedString("active")}</InputLabel>
                <Select
                  disabled={!data?.editable}
                  value={formData.active ? "Y" : "N"}
                  labelId={`label-active`}
                  id={`select-active`}
                  onChange={(e) => setFormValue(e.target.value === "Y", "active")}
                  margin={"none"}
                >
                  {
                    getYesNoArray().map((item) => (
                      <MenuItem
                        className={"whiteText"}
                        key={item.key}
                        value={item.key}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <TextFieldMultiline
                disabled={!data?.editable}
                required
                fullWidth
                rows={3}
                margin={"none"}
                label={getLocalizedString("description")}
                value={formData.description}
                onChange={(e) => setFormValue(e.target.value.substring(0, 250), "description")}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <TextFieldMultiline
                disabled={!data?.editable}
                fullWidth
                rows={6}
                margin={"none"}
                label={getLocalizedString("visualizationFilter")}
                value={formData.sqlFilter}
                onChange={(e) => setFormValue(e.target.value, "sqlFilter")}
                helperText={<span style={{ whiteSpace: "pre-wrap" }}>{getLocalizedString("moduleVisualizationFilterHelperText")}</span>}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
          <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default ModuleFormDialog;
